<template>
  <v-card :class="[$root.isRTL ? 'fullContentRTL' : 'fullContent']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">local_atm</i>יזמים
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
    </v-toolbar>
    <div style="width: 100%;">
      <div style="text-align: right;">
        <v-icon v-if="$root.isAdmin" @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
        <input type="checkbox" v-model="isActiveUsers" class="w3-check"> הצג פעיל בלבד
      </div>
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp">שם יזם</th>
          <th class="tdData">ת.ז. / ח.פ.</th>
          <th class="tdData">פעיל</th>
          <th class="tdCtrl" style="width: 160px!important;" v-if="$root.isAdmin"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="hasData">
        <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in filteredRows">
            <td class="tdData sp">{{row.FullName}}</td>
            <td class="tdData tdTxt">{{row.Identity}}</td>
            <td class="tdData">
              <v-icon v-if="row.Active" class="green--text">done</v-icon>
              <v-icon v-else class="red--text">block</v-icon>
            </td>
            <td class="tdCtrl tdTxt" style="width: 160px!important;" v-if="$root.isAdmin">
              <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
              <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
            </td>
          </tr>
        </table>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;">אין נתונים</h3>
      </div>
      <PopupUser></PopupUser>
    </div>
  </v-card>
</template>

<script>

  import { db, auth } from '../firebase';
  var usersRef = db.ref('Users');
  import PopupUser from '../components/PopupUser';

  export default {
    name: 'Entrepreneurs',
    components: { PopupUser },
    data() {
      return {
        txtSearch: '',
        users: [],
        contractors: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'יזם', Password: '', Active: false, Approved: false },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        users: usersRef.orderByChild("Type").equalTo("יזם")
      }
    },
    created() {
      this.$Log("Vue [Entrepreneurs] is created ...");
      var vm = this;
      if (!vm.$root.isAdmin) {
        vm.loadMyContractors();
      }
    },
    ready() {
      this.$Log("Vue [Entrepreneurs] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Entrepreneurs] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Entrepreneurs] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.$root.isAdmin) {
          return vm.filteredRowsWithPermission(vm.users);
        }
        else {
          return vm.filteredRowsWithPermission(vm.contractors);
        }
      },
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveEntrepreneur') {
          this.remove();
        }
      }
    },
    methods: {
      filteredRowsWithPermission(usersArr) {
        var vm = this;
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            result = usersArr.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  if (vm.isActiveUsers) {
                    if (row.Active) {
                      return row;
                    }
                  }
                  else {
                    return row;
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          if (vm.isActiveUsers) {
            result = usersArr.filter(function (row) {
              if (row.Active) {
                return row;
              }
            });
          }
          else {
            result = usersArr;
          }
        }

        return result;
      },
      loadMyContractors() {
        var vm = this;
        vm.contractors = [];
        var customerKey = vm.$root.user['.key'];
        var diariesRef = db.ref('Diaries');
        diariesRef.orderByChild("CustomerKey").equalTo(customerKey).once('value').then(function (snapshot) {
          let obj = snapshot.val();
          if (obj) {
            let keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
              let key = keys[i];
              let diary = obj[key];
              console.log("diary >>>> " + JSON.stringify(diary));
              if (diary.AddedUsers && diary.AddedUsers.length > 0) {
                for (var u = 0; u < diary.AddedUsers.length; u++) {
                  let user = vm.users.find(function (usr) {
                    return usr['.key'] == diary.AddedUsers[u].UserKey;
                  });

                  if (user) {
                    let userExist = vm.contractors.find(function (exist) {
                      return exist['.key'] == user['.key'];
                    });
                    if (!userExist) {
                      vm.contractors.push(user);
                    }
                  }
                }
              }
            }
          }
        });
      },
      currency(N) {
        N = parseFloat(N);
        if (!isNaN(N))
          N = N.toFixed(2);
        else
          N = '0.00';
        return N + " ₪";
      },
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'יזם חדש',
          data: { '.key': '', FullName: '', Username: '', Identity: '', Type: 'יזם', Password: '', Active: true, Approved: false }
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת יזם',
          data: {
            '.key': row['.key'],
            FullName: row.FullName,
            Username: row.Username,
            Identity: row.Identity,
            Type: row.Type,
            Password: row.Password,
            Active: row.Active,
            Approved: row.Approved
          }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveEntrepreneur',
          isConfirmed: false
        }
      },
      remove() {
        usersRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var vm = this;

        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };

        usersRef.push(item);
      },
      update() {
        var item = {
          FullName: this.popup.data.FullName,
          Username: this.popup.data.Username,
          Identity: this.popup.data.Identity,
          Type: this.popup.data.Type,
          Password: this.popup.data.Password,
          Active: this.popup.data.Active,
          Approved: this.popup.data.Approved
        };
        usersRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// Entrepreneurs.vue?db27c478